module.exports = __webpack_public_path__ + "img/cqbVtFvZ.ece87fb4.svg";